
import {defaults as defaultControls, Control} from 'ol/control';
import {CLASS_CONTROL, CLASS_UNSELECTABLE} from 'ol/css';

require('es6-promise').polyfill();

export class LegendControl extends Control {
    isActive=false;

    constructor(options) {

        super({
            element: document.createElement('div')
        });

        this.options = options;
        this.wmsLayer=options.wmsLayer;

        this.isActive = false;
        const self=this;

        const className = options.className !== undefined ? options.className : 'ol-legend';
        const cssClasses = className + ' ' + CLASS_UNSELECTABLE ;
        const element=this.element;
        element.className=cssClasses;
        const mainDiv=document.createElement('div');
        mainDiv.className="ol-legend-main";
        mainDiv.innerHTML="Legenda";
        this.legendImg= document.createElement('img');
        mainDiv.appendChild(this.legendImg);
        element.appendChild(mainDiv);
        //document.body.appendChild(element);

    }

    updateLegend (resolution) {
        if(!resolution) resolution = this.getMap().getView().getResolution();
        var graphicUrl = this.wmsLayer.getSource().getLegendUrl(resolution);
        this.legendImg.src = graphicUrl;
    };

}